// SAMPLE DATA — not a real motion, not a real member, not a real ballot.
//
// One hardcoded paper so the screen can be looked at before any of sign-in,
// submission or persistence exists. It lives in its own file, and says so at the
// top of that file, precisely so nobody mistakes it for something the app
// fetched. When the real ballot arrives over the wire it replaces this object
// and nothing else on the page changes.
//
// The names are invented (Privacy Act / no real records in sample data). The
// item is shaped as a constitutional amendment because that is the sharpest of
// the three majority bases: §15.2 counts the members SUMMONED to each House, so
// a member who does not vote has cast a No — the rule most likely to be
// misunderstood, and therefore the one worth looking at first.

import type { BallotPaperView } from '../paper';

export const SAMPLE_PAPER: BallotPaperView = {
  ballotId: 'sample-synod-2026',
  mode: 'sandbox',
  state: 'open',
  itemNumber: 2,
  itemCount: 5,
  elector: {
    name: 'Jane Doe',
    house: 'laity',
  },
  paper: {
    item: {
      kind: 'motion',
      id: 'sample-motion-2',
      title: 'Motion 2 — Amendment to Clause 15 of the Constitution',
      motionClass: 'constitutional-amendment',
      threshold: { kind: 'super', numerator: 2, denominator: 3 },
      base: 'summoned-per-house',
      // Mandatory for this base, and validated by the engine: a single tally
      // against a summed summons list would let one House carry the other.
      byHouses: true,
    },
    instrument:
      'That Clause 15 of the Constitution be amended by deleting from sub-clause 15.1 the ' +
      'words “twenty-one days” and inserting in their place the words “twenty-eight days”, so ' +
      'that the notice required before an amendment to the Constitution may be considered by ' +
      'Synod is lengthened accordingly; and that the amendment take effect from the close of ' +
      'this session.',
    mover: 'The Revd A. Mover',
    seconder: 'Mr B. Seconder',
  },
};
